import { getCurrentLangFromRedux, getDir } from "../../algorithms/styleChanges";
import {
  contentEnd,
  contentStart,
  customStyle,
  styleEnd,
  styleStart,
} from "../../algorithms/styleDirection";
import Icon from "../sharedComponents/icons/fontawsomeIcons";
import { Link } from "react-router-dom";
import "moment/locale/ar";
import Lang from "../../userPreferences/staticWords";
import { useEffect, useState } from "react";
import { paths } from "../../paths/paths";
import ModalComponent from "../reusableComponents/modal";
import AddProcedureForm from "../tasks/addProcedure/addProcedureForm";
import { formatDateLL } from "../../algorithms/index";
import { resolver } from "../../API/middlewares/resolveRequests";
import AddTaskAttachments from "../tasks/addTaskAttachmentPopup";
import DeleteProcAlert from "../tasks/editProc.js/deleteProc";
import { useSelector } from "react-redux";
import { getEditDataActivityForm } from "../../API/store/actions/projects/projects";
import EditActivityForm from "./editActivity";
import ActivityStatus from "./activityStatus/activityStatus";

const ActivityCard = ({
  setProcAdded,
  procAdded,
  ActivitiesWithProcedures,
  projectId,
}) => {
  const community = useSelector((state) => state.community.communityId);
  const [show, setshow] = useState({ id: null, display: false });
  const communityId = useSelector((state) => state.community.communityId?.id);

  //for slicing content
  // let slicedBrief = item.brief;
  // if (item.brief !== null && item.brief.length > 150) {
  //   const brief = item.brief;
  //   slicedBrief = brief.substring(0, 140).concat(" ...");
  // }
  // const id = ActivitiesWithProcedures?.data.id;
  // const taskStatus = ActivitiesWithProcedures?.data?.taskStatus?.id;
  const [visibleProc, setVisibleProc] = useState(false);
  const [visibleStatus, setVisibleStatus] = useState(false);
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [activityId, setactivityId] = useState(null);
  const [taskTitle, setTaskTitle] = useState(null);

  const [showAttachmentPopup, setShowAttachmentPopup] = useState(false);
  const onShowAttachments = () => {
    setShowAttachmentPopup(true);
  };
  const renderAttachmentsModal = (activityId) => {
    return (
      <AddTaskAttachments
        procAdded={procAdded}
        setProcAdded={setProcAdded}
        activityId={activityId}
        show={showAttachmentPopup}
        onHide={() => setShowAttachmentPopup(false)}
      />
    );
  };
  const [data, setData] = useState(null);
  useEffect(() => {
    if (data?.data?.startDate && data?.data?.endDate) setVisibleEdit(true);
  }, [data]);

  const userToken = useSelector((state) => state.login.userToken);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);

  document.onclick = function (event) {
    if (
      !event.target.matches(".icon") &&
      !event.target.matches(".icon svg path")
    ) {
      var sharedowns = document.getElementsByClassName(
        `${customStyle("dropdown-menu")}`
      );
      for (let i = 0; i < sharedowns?.length; i++) {
        var openSharedown = sharedowns[i];
        if (openSharedown?.classList?.contains("show")) {
          openSharedown?.classList?.remove("show");
          setshow({ id: null, display: false });
        }
      }
    }
  };

  if (ActivitiesWithProcedures?.length > 0) {
    return (
      <>
        <ModalComponent
          body={
            <DeleteProcAlert
              userToken={userToken}
              setProcAdded={setProcAdded}
              procAdded={procAdded}
              activityId={activityId}
              setVisible={setDeleteModalVisible}
              content={"هل تريد حذف النشاط والإجراءات الملحقة ؟"}
            />
          }
          hasImage={
            <img
              src="/assets/images/deleteicon.png"
              width={20}
              height={20}
              alt=""
            />
          }
          size={"s"}
          modalVisible={deleteModalVisible}
          setModalVisible={setDeleteModalVisible}
          title={"هل انت متاكد"}
          background={"modalBackground mx-5"}
        />

        <ModalComponent
          body={
            <EditActivityForm
              projectId={projectId}
              userToken={userToken}
              activityId={activityId}
              setVisible={setVisibleEdit}
              data={data?.data}
              setProcAdded={setProcAdded}
              procAdded={procAdded}
            />
          }
          hasImage={
            <img
              src="/assets/images/greeniconedit.svg"
              width={20}
              height={20}
              alt=""
            />
          }
          setModalVisible={setVisibleEdit}
          modalVisible={visibleEdit}
          size={"xl"}
          title={Lang.editActivity}
        />

        <ModalComponent
          body={
            <ActivityStatus
              userToken={userToken}
              taskTitle={taskTitle}
              activityId={activityId}
              setVisible={setVisibleStatus}
              procAdded={procAdded}
              setProcAdded={setProcAdded}
            />
          }
          hasImage={
            <img
              src="/assets/images/icons/status.png"
              width={20}
              height={20}
              alt=""
            />
          }
          setModalVisible={setVisibleStatus}
          modalVisible={visibleStatus}
          size={"xl"}
          title={"تغيير حالة النشاط"}
        />
        <ModalComponent
          body={
            <AddProcedureForm
              activityId={activityId}
              setVisible={setVisibleProc}
              setProcAdded={setProcAdded}
              procAdded={procAdded}
              userToken={userToken}
            />
          }
          hasImage={
            <div
              style={{
                backgroundColor: "#1A73E8",
                height: 26,
                width: 26,
                cursor: "pointer",
                borderRadius: "50%",
              }}
              className="d-flex justify-content-center text-center align-items-center itemNav plusIcon"
            >
              <div
                style={{
                  width: 16,
                  height: 16,
                  background:
                    "url('/assets/images/icons/Path 184.png') 0% 0% no-repeat padding-box",
                  opacity: 1,
                  filter: "opacity(1) brightness(20)",
                }}
                className="any"
              ></div>
            </div>
          }
          setModalVisible={setVisibleProc}
          modalVisible={visibleProc}
          size={"xl"}
          title={Lang.addProcedure}
        />

        <div
          className={`d-flex flex-column align-self-center col-xl-12 col-lg-8 col-11 ${styleStart(
            "m",
            4,
            "lg"
          )} ${styleEnd("p", 4, "lg")} mt-3 mx-0`}
        >
          {ActivitiesWithProcedures?.map((item, index) => {
            let newCreateDate, userPhoto;
            if (item?.lastActivityProcedure)
              newCreateDate = item.lastActivityProcedure.startDate.split(
                "."
              )[0];
            if (item?.lastActivityProcedure?.memberPhoto != null)
              userPhoto = `url("${paths.MemberPhoto}${item.lastActivityProcedure.memberId}/${item.lastActivityProcedure.memberPhoto}")`;
            else userPhoto = `url("/assets/images/userPlaceholder.png")`;
            return (
              <div
                className="d-flex flex-column col-12 my-3 taskCard"
                style={{
                  border: "1px solid #C7C7C9",
                  borderRadius: 10,
                  height: "fit-content",
                }}
                key={item.id}
              >
                <div className="d-flex align-items-start px-4 pt-3">
                  {/* stage of activity if there is activity */}
                  {item.milestone ? (
                    <div
                      className="d-flex align-items-center px-3 py-2"
                      style={{
                        backgroundColor: "#C7DEFB",
                        borderRadius: 10,
                        width: "fit-content",
                        fontSize: 12,
                      }}
                    >
                      <div className="d-flex justify-content-center align-items-center">
                        <p className="m-0">{item.milestone}</p>
                      </div>
                    </div>
                  ) : null}

                  <div className="col d-flex justify-content-end align-items-start btn-group">
                    {show.id == item.id ? (
                      <>
                        <div
                          style={{ display: show.display ? "block" : "none" }}
                          className={`${customStyle("arrow-horizontal")} ${
                            show.display ? "show" : ""
                          }`}
                        ></div>
                        <ul
                          className={`${customStyle("dropdown-menu")} ${
                            show.display ? "show" : ""
                          }`}
                          style={{
                            display: show.display ? "block" : "none",
                          }}
                        >
                          <li
                            style={{ cursor: "pointer" }}
                            id={item.id}
                            onClick={(e) => {
                              const currentId = e.currentTarget.id;
                              resolver(
                                getEditDataActivityForm,
                                setData,
                                currentId,
                                communityId,
                                userToken
                              );
                              setactivityId(currentId);
                            }}
                          >
                            <span
                              className={`dropdown-item ${customStyle(
                                "dropdown-item"
                              )}`}
                            >
                              تعديل النشاط
                            </span>
                          </li>

                          <li style={{ cursor: "pointer" }}>
                            <span
                              onClick={() => {
                                setactivityId(item.id);
                                setTaskTitle(item.name);
                                setVisibleStatus(true);
                              }}
                              className={`dropdown-item ${customStyle(
                                "dropdown-item"
                              )}`}
                            >
                              تعديل الحالة
                            </span>
                          </li>
                          <li
                            style={{ cursor: "pointer" }}
                            id={item.id}
                            onClick={(e) => {
                              const currentId = e.currentTarget.id;
                              // if (currentId == null) {
                              setactivityId(currentId);
                              // } else if (id == show.id) {
                              //   setId(null);
                              // } else {
                              //   setId(currentId);
                              // }
                              onShowAttachments();
                            }}
                          >
                            <span
                              className={`dropdown-item ${customStyle(
                                "dropdown-item"
                              )}`}
                            >
                              اضافة مرفقات
                            </span>
                          </li>
                          <li
                            style={{ cursor: "pointer" }}
                            id={item.id}
                            onClick={(e) => {
                              const currentId = e.currentTarget.id;
                              setactivityId(currentId);
                              setDeleteModalVisible(true);
                            }}
                          >
                            <span
                              className={`dropdown-item ${customStyle(
                                "dropdown-item"
                              )}`}
                            >
                              حذف النشاط
                            </span>
                          </li>
                        </ul>
                      </>
                    ) : null}
                  </div>

                  {community?.adminProject && (
                    <Icon
                      id={item.id}
                      name="ellipsis-v"
                      size={18}
                      className="icon"
                      onclick={(e) => {
                        const id = e.currentTarget.id;
                        id == null
                          ? setshow({
                              id,
                              display: true,
                            })
                          : id == show.id
                          ? setshow({
                              id: null,
                              display: false,
                            })
                          : setshow({
                              id,
                              display: true,
                            });
                      }}
                    />
                  )}
                </div>

                {/* title */}
                <div className="d-flex align-items-start px-4 py-3">
                  <div
                    className={`d-flex justify-content-center align-items-center col-1 ${styleEnd(
                      "m",
                      2
                    )}`}
                    style={{
                      border: "1px solid #1A73E8",
                      borderRadius: "50%",
                      width: 27,
                      height: 27,
                      fontSize: 12,
                    }}
                  >
                    {item.id}
                  </div>
                  <Link
                    className={`my-0 ${styleEnd(
                      "m",
                      3
                    )} text-decoration-none text-dark`}
                    style={{
                      lineHeight: 1.5,
                      fontSize: 18,
                      fontWeight: "bold",
                    }}
                    to={`/activityDetails/${item.id}`}
                  >
                    {item.name}
                  </Link>
                </div>

                {/* date */}
                <div className="d-flex align-items-center px-4">
                  <p className="text-muted" style={{ fontSize: 14 }}>
                    {Lang.inPeriod}
                    <span>
                      &nbsp;&nbsp;&nbsp;{Lang.from}{" "}
                      {`${formatDateLL(item.startDate)}`}
                    </span>{" "}
                    <span>
                      &nbsp;&nbsp;&nbsp;{Lang.to}{" "}
                      {`${formatDateLL(item.endDate)}`}
                    </span>
                  </p>
                </div>

                {/* icons */}
                <div className="d-flex flex-wrap align-items-center px-4 py-2">
                  {/* <div
                    className={`d-flex justify-content-center py-2 px-3 ${styleEnd(
                      "m",
                      2
                    )} mb-2`}
                    style={{
                      backgroundColor: "#F2F2F2",
                      width: "fit-content",
                      borderRadius: 10,
                    }}
                  >
                    <div className={`${styleEnd("m", 2)}`}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16.883"
                        height="18"
                        viewBox="0 0 16.883 18"
                      >
                        <path
                          id="_001-clock"
                          data-name="001-clock"
                          d="M8.442,18.25C.949,18.242-2.821,8.53,2.473,2.871a8.107,8.107,0,0,1,11.938,0C19.7,8.531,15.934,18.242,8.442,18.25Zm0-16.61a7.382,7.382,0,0,0-7.123,7.6c.391,10.084,13.855,10.081,14.245,0A7.382,7.382,0,0,0,8.442,1.64Zm3.071,9.884L9.429,9.3A1.092,1.092,0,0,0,9.1,8.454c0-.007,0-.015,0-.022V4.314a.661.661,0,1,0-1.319,0V8.432c0,.007,0,.015,0,.022A1.066,1.066,0,0,0,8.5,10.3l2.084,2.224a.631.631,0,0,0,.933,0,.738.738,0,0,0,0-1Z"
                          transform="translate(0 -0.25)"
                          fill={item?.dayCount?.color ?? "#3ec4b8"}
                        />
                      </svg>
                    </div>
                    <div className="d-flex align-items-center justify-content-center">
                      <p className="my-0">
                        {item.dayCount.day >= 0 ? item.dayCount.day : ""}&nbsp;
                        {item.dayCount.daystatus}
                      </p>
                    </div>
                  </div> */}

                  {item.activityStatus ? (
                    <div
                      className={`d-flex justify-content-center py-2 px-3 ${styleEnd(
                        "m",
                        2
                      )} mb-2`}
                      style={{
                        backgroundColor: "#F2F2F2",
                        width: "fit-content",
                        borderRadius: 10,
                      }}
                    >
                      <div className={`${styleEnd("m", 2)}`}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                        >
                          <g
                            id="technical-support_1_"
                            data-name="technical-support (1)"
                            transform="translate(0 0.001)"
                          >
                            <path
                              id="Path_428"
                              data-name="Path 428"
                              d="M3.165,13.919a1.468,1.468,0,0,0-.709.181A8.3,8.3,0,0,1,10.652.867a.352.352,0,0,0,.139-.689A9.067,9.067,0,0,0,9,0,9,9,0,0,0,1.936,14.577a1.477,1.477,0,1,0,1.229-.658Zm.547,2.023a.773.773,0,1,1,.227-.547A.768.768,0,0,1,3.712,15.943Zm0,0"
                              transform="translate(0)"
                              fill={item?.activityStatus?.color}
                            />
                            <path
                              id="Path_429"
                              data-name="Path 429"
                              d="M206.6,34.346a1.473,1.473,0,1,0-.52.477,8.3,8.3,0,0,1-8.18,13.236.352.352,0,1,0-.138.69,9.073,9.073,0,0,0,1.775.175A9,9,0,0,0,206.6,34.346Zm-1.776-.272a.774.774,0,1,1,.547.226A.768.768,0,0,1,204.828,34.074Zm0,0"
                              transform="translate(-190.541 -30.925)"
                              fill={item?.activityStatus?.color}
                            />
                            <path
                              id="Path_430"
                              data-name="Path 430"
                              d="M78.932,86.445a.352.352,0,0,0,.352.352h2.2a.352.352,0,0,0,.352-.352v-.682a5.505,5.505,0,0,0,1.319-.547l.481.481a.351.351,0,0,0,.5,0l1.554-1.555a.352.352,0,0,0,0-.5l-.481-.481a5.5,5.5,0,0,0,.547-1.319h.679a.352.352,0,0,0,.352-.352V79.3a.352.352,0,0,0-.352-.352h-.679a5.505,5.505,0,0,0-.547-1.319l.478-.478a.352.352,0,0,0,0-.5L84.127,75.1a.352.352,0,0,0-.5,0l-.477.477a5.5,5.5,0,0,0-1.319-.547v-.675A.352.352,0,0,0,81.482,74h-2.2a.352.352,0,0,0-.352.352v.675a5.5,5.5,0,0,0-1.319.547l-.477-.477a.352.352,0,0,0-.5,0L75.084,76.65a.351.351,0,0,0,0,.5l.478.478a5.5,5.5,0,0,0-.547,1.319h-.678a.352.352,0,0,0-.352.351v2.2a.351.351,0,0,0,.352.352h.679a5.506,5.506,0,0,0,.547,1.319l-.481.481a.352.352,0,0,0,0,.5L76.635,85.7a.352.352,0,0,0,.249.1h0a.352.352,0,0,0,.249-.1l.481-.481a5.51,5.51,0,0,0,1.319.547Zm-1.182-1.968a.352.352,0,0,0-.439.047l-.428.428-1.057-1.058.428-.428a.351.351,0,0,0,.047-.439,4.812,4.812,0,0,1-.666-1.607.352.352,0,0,0-.344-.278h-.6v-1.5h.6a.352.352,0,0,0,.344-.278,4.812,4.812,0,0,1,.666-1.607.351.351,0,0,0-.047-.439l-.425-.425,1.058-1.057.424.425a.352.352,0,0,0,.439.047,4.81,4.81,0,0,1,1.607-.666.352.352,0,0,0,.278-.344v-.6h1.5v.6a.351.351,0,0,0,.278.344,4.814,4.814,0,0,1,1.607.666.351.351,0,0,0,.439-.047l.425-.424L84.937,76.9l-.425.425a.351.351,0,0,0-.047.439,4.815,4.815,0,0,1,.666,1.607.351.351,0,0,0,.344.278h.6v1.5h-.6a.352.352,0,0,0-.344.278,4.811,4.811,0,0,1-.666,1.607.352.352,0,0,0,.047.439l.428.428-1.057,1.058-.428-.428a.351.351,0,0,0-.439-.047,4.815,4.815,0,0,1-1.607.666.352.352,0,0,0-.278.344v.607h-1.5v-.607a.352.352,0,0,0-.278-.344A4.812,4.812,0,0,1,77.751,84.477Zm0,0"
                              transform="translate(-71.384 -71.399)"
                              fill={item?.activityStatus?.color}
                            />
                            <path
                              id="Path_431"
                              data-name="Path 431"
                              d="M179.181,176.276a2.9,2.9,0,1,0-2.9,2.9A2.908,2.908,0,0,0,179.181,176.276Zm-5.107,0a2.2,2.2,0,1,1,2.2,2.2A2.2,2.2,0,0,1,174.074,176.276Zm0,0"
                              transform="translate(-167.277 -167.277)"
                              fill={item?.activityStatus?.color}
                            />
                            <path
                              id="Path_432"
                              data-name="Path 432"
                              d="M338.43,18.512a.352.352,0,1,0-.248-.1A.354.354,0,0,0,338.43,18.512Zm0,0"
                              transform="translate(-326.193 -17.183)"
                              fill={item?.activityStatus?.color}
                            />
                            <path
                              id="Path_433"
                              data-name="Path 433"
                              d="M154.711,474.359a.352.352,0,1,0,.249.1A.355.355,0,0,0,154.711,474.359Zm0,0"
                              transform="translate(-148.933 -457.683)"
                              fill={item?.activityStatus?.color}
                            />
                          </g>
                        </svg>
                      </div>
                      <div className="d-flex align-items-center justify-content-center">
                        <p className="my-0">{item?.activityStatus?.name}</p>
                      </div>
                    </div>
                  ) : null}

                  {item.activityPriority ? (
                    <div
                      className={`d-flex justify-content-center py-2 px-3 ${styleEnd(
                        "m",
                        2
                      )} mb-2`}
                      style={{
                        backgroundColor: "#F2F2F2",
                        width: "fit-content",
                        borderRadius: 10,
                      }}
                    >
                      <div className={`${styleEnd("m", 2)}`}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="14.541"
                          viewBox="0 0 16 14.541"
                        >
                          <g
                            id="Group_303"
                            data-name="Group 303"
                            transform="translate(-708 -230.459)"
                          >
                            <path
                              id="Path_344"
                              data-name="Path 344"
                              d="M12.108,35a2.108,2.108,0,1,0,2.108,2.108A2.108,2.108,0,0,0,12.108,35Zm0,3.3a1.171,1.171,0,1,1,1.171-1.171A1.171,1.171,0,0,1,12.108,38.3Z"
                              transform="translate(700.57 203.164)"
                              fill={item?.activityPriority?.color}
                            />
                            <path
                              id="Path_345"
                              data-name="Path 345"
                              d="M9.529,5A6.436,6.436,0,0,0,3.1,11.246l-.582-.417a.5.5,0,0,0-.645.052L.852,11.906A.5.5,0,0,0,.8,12.55l.5.712-.055.135-.867.145a.5.5,0,0,0-.417.5v1.444a.5.5,0,0,0,.417.5l.867.145.055.135-.5.712a.5.5,0,0,0,.052.645l1.024,1.024a.5.5,0,0,0,.645.052l.715-.5.132.055.145.869a.5.5,0,0,0,.5.417H5.456a.5.5,0,0,0,.5-.417l.145-.869.132-.055.715.5a.5.5,0,0,0,.645-.052l.847-.879A6.43,6.43,0,1,0,9.529,5ZM7.158,16.588,7.6,17.2l-.422.422-.612-.437a.5.5,0,0,0-.532-.035,2.683,2.683,0,0,1-.535.225.5.5,0,0,0-.345.395l-.125.75H4.43l-.125-.75a.5.5,0,0,0-.337-.395,2.683,2.683,0,0,1-.535-.225.5.5,0,0,0-.532.035l-.62.437L1.859,17.2l.437-.612a.5.5,0,0,0,.032-.535,2.581,2.581,0,0,1-.22-.527.5.5,0,0,0-.39-.35l-.75-.125v-.595l.75-.125a.5.5,0,0,0,.39-.337,2.581,2.581,0,0,1,.22-.527.5.5,0,0,0-.032-.535l-.437-.625.422-.422.612.437a.5.5,0,0,0,.535.032,2.581,2.581,0,0,1,.54-.22.5.5,0,0,0,.337-.39L4.43,11h.595l.125.75a.5.5,0,0,0,.35.4,2.581,2.581,0,0,1,.527.22.5.5,0,0,0,.535-.032l.612-.437.422.422-.437.6a.5.5,0,0,0-.035.532,2.683,2.683,0,0,1,.225.535.5.5,0,0,0,.395.345l.75.125v.595l-.75.125a.5.5,0,0,0-.395.345,2.683,2.683,0,0,1-.225.535.5.5,0,0,0,.035.532Zm2.371.275a5.5,5.5,0,0,1-1.014-.1l-.372-.522c.02-.042.037-.087.055-.132l.869-.145a.5.5,0,0,0,.417-.5V14.032a.5.5,0,0,0-.417-.5L8.2,13.387c-.017-.045-.035-.09-.055-.132l.5-.715a.5.5,0,0,0-.052-.645L7.565,10.871a.5.5,0,0,0-.645-.052l-.712.5-.135-.055L5.929,10.4a.5.5,0,0,0-.5-.417H4.29a5.432,5.432,0,1,1,5.247,6.866Z"
                              transform="translate(708.04 225.459)"
                              fill={item?.activityPriority?.color}
                            />
                            <path
                              id="Path_346"
                              data-name="Path 346"
                              d="M37.2,15.108V11.048a.468.468,0,0,0-.937,0V15.3a.468.468,0,0,0,.138.33L38.2,17.438a.47.47,0,0,0,.661-.67Z"
                              transform="translate(680.936 221.186)"
                              fill={item?.activityPriority?.color}
                            />
                          </g>
                        </svg>
                      </div>
                      <div className="d-flex align-items-center justify-content-center">
                        <p className="my-0">{item?.activityPriority?.name}</p>
                      </div>
                    </div>
                  ) : null}

                  <div
                    className="d-flex justify-content-center py-2 px-3 mb-2"
                    style={{
                      backgroundColor: "#F2F2F2",
                      width: "fit-content",
                      borderRadius: 10,
                    }}
                  >
                    <div className="d-flex">
                      <div
                        className={`d-flex justify-content-center align-items-center ${styleEnd(
                          "m",
                          2
                        )}`}
                        style={{
                          border: "1px solid #1A73E8",
                          backgroundColor: "#1A73E8",
                          color: "white",
                          borderRadius: "50%",
                          width: 24,
                          height: 24,
                          fontSize: 12,
                        }}
                      >
                        {item.activityProceduresCount ?? 0}
                      </div>
                      <div className="d-flex align-items-center justify-content-center">
                        <p className="my-0">
                          {item.activityProceduresCount > 1
                            ? Lang.procedures
                            : Lang.procedure}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* procedures section */}
                <div
                  style={{
                    backgroundColor: "#F2F2F2",
                    borderRadius: 10,
                  }}
                >
                  <div
                    className={`d-flex mx-4 py-2 align-items-center ${styleStart(
                      "p",
                      5,
                      "md"
                    )} ${styleStart("p", 4, "xl")}`}
                  >
                    <span className="text-muted" style={{ fontSize: 15 }}>
                      {item.activityProceduresCount > 0
                        ? Lang.lastProcedureWasAdded
                        : Lang.thereIsNoProcedures}
                    </span>
                    <hr
                      className="col-md-3 col-lg-5 col-xl-7 mx-2 d-none d-sm-block"
                      style={{ backgroundColor: "#707070" }}
                    ></hr>
                    <div
                      className={`d-flex align-items-center col ${
                        getDir(getCurrentLangFromRedux()) === "rtl"
                          ? contentStart("justify-content")
                          : contentEnd("justify-content")
                      } ${
                        getDir(getCurrentLangFromRedux()) === "rtl"
                          ? contentEnd("justify-content", "md")
                          : contentStart("justify-content", "md")
                      }`}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setactivityId(item.id);
                        setVisibleProc(true);
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#1A73E8",
                          height: 26,
                          width: 26,
                          cursor: "pointer",
                          borderRadius: "50%",
                        }}
                        className="d-flex justify-content-center text-center align-items-center itemNav plusIcon"
                      >
                        <div
                          style={{
                            width: 16,
                            height: 16,
                            background:
                              "url('/assets/images/icons/Path 184.png') 0% 0% no-repeat padding-box",
                            opacity: 1,
                            filter: "opacity(1) brightness(20)",
                          }}
                          className="any"
                        ></div>
                      </div>
                      <span className="mx-2">{Lang.addProcedure}</span>
                    </div>
                  </div>

                  {item.lastActivityProcedure ? (
                    <>
                      <div className="d-flex flex-md-row flex-column px-4 align-items-center">
                        <div className="d-flex align-items-center justify-content-md-start justify-content-center my-2 col-12 col-md-7">
                          <div
                            style={{
                              backgroundImage: userPhoto,
                              width: 40,
                              height: 40,
                              borderRadius: "50%",
                              backgroundPosition: "center",
                              backgroundRepeat: "no-repeat",
                              backgroundSize: "cover",
                              border: "1px solid white",
                            }}
                          ></div>
                          <p
                            className="mx-2 my-0"
                            style={{ fontWeight: "bold" }}
                          >
                            {item.lastActivityProcedure.memberName}
                          </p>
                        </div>
                        <div className="col-12 col-md-4 col-xl-5 d-flex px-xl-4 my-2 justify-content-md-end justify-content-center">
                          <span
                            className={`text-muted ${styleStart(
                              "m",
                              0
                            )} ${styleEnd("m", 4, "md")} `}
                            style={{ fontSize: 14 }}
                          >
                            {`${formatDateLL(newCreateDate)}`}
                          </span>
                        </div>
                      </div>

                      <div
                        className="d-flex px-md-5 mx-4 align-items-center"
                        style={{
                          textAlign: "justify",
                          fontSize: 16,
                          color: "#444444",
                        }}
                      >
                        <p>{item.lastActivityProcedure.description}</p>
                      </div>

                      {/* add Comment section */}
                      {/* <div className="d-flex px-5 mx-5 mb-2">
                        <div
                          style={{
                            width: 1,
                            height: 25,
                            backgroundColor: "#707070",
                          }}
                        ></div>
                        <div
                          className="mt-4"
                          style={{
                            width: 10,
                            height: 1,
                            backgroundColor: "#707070",
                          }}
                        ></div>
                        <div
                          className="d-flex justify-content-center py-2 px-3"
                          style={{ cursor: "pointer" }}
                        >
                          <div>
                            <svg
                              id="fi-br-comment-alt"
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="15.851"
                              viewBox="0 0 16 15.851"
                            >
                              <path
                                id="Path_74"
                                data-name="Path 74"
                                d="M12.333,0H3.667A3.671,3.671,0,0,0,0,3.667v6a3.671,3.671,0,0,0,3.667,3.667h.959l2.733,2.285a1,1,0,0,0,1.283,0l2.733-2.285h.959A3.671,3.671,0,0,0,16,9.667v-6A3.671,3.671,0,0,0,12.333,0ZM14,9.667a1.667,1.667,0,0,1-1.667,1.667H11.011a1,1,0,0,0-.641.233L8,13.548,5.63,11.567a1,1,0,0,0-.641-.233H3.667A1.667,1.667,0,0,1,2,9.667v-6A1.667,1.667,0,0,1,3.667,2h8.667A1.667,1.667,0,0,1,14,3.667Z"
                                fill="#1a73e8"
                              />
                              <path
                                id="Path_75"
                                data-name="Path 75"
                                d="M7.167,8.333H9.5A1.167,1.167,0,0,0,9.5,6H7.167a1.167,1.167,0,0,0,0,2.333Z"
                                transform="translate(-2.667 -2.289)"
                                fill="#1a73e8"
                              />
                              <path
                                id="Path_76"
                                data-name="Path 76"
                                d="M14.853,11H7.265a1.265,1.265,0,0,0,0,2.529h7.588a1.265,1.265,0,0,0,0-2.529Z"
                                transform="translate(-3 -3.196)"
                                fill="#1a73e8"
                              />
                            </svg>
                          </div>
                          <div className="d-flex col-12 align-items-center justify-content-center">
                            <p className="my-0">إضافة ملاحظة</p>
                          </div>
                        </div>
                      </div> */}
                    </>
                  ) : null}
                </div>
              </div>
            );
          })}
          {renderAttachmentsModal(activityId)}
        </div>
      </>
    );
  } else {
    return (
      <div className="my-5 d-flex justify-content-center col-xl-12 col-lg-8 col-11">
        {Lang.noActivitiesYet}
      </div>
    );
  }
};

export default ActivityCard;
